module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0 && item.path !== '/dataBoard') ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.children[0].name)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.hidden && item.noDropdown && item.children.length > 0 && item.path === '/dataBoard') ? _c('router-link', {
      attrs: {
        "to": '/largeScreen'
      }
    }, [_c('el-menu-item', {
      staticClass: "submenu-title-noDropdown",
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.children[0].name)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.name
      }
    }, [(!item.icon.includes('el-icon')) ? _c('template', {
      slot: "title"
    }, [(item.icon) ? _c('icon-svg', {
      attrs: {
        "icon-class": item.icon
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.name)))])], 1) : _vm._e(), _vm._v(" "), (item.icon.includes('el-icon')) ? _c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "icon-I",
      class: item.icon
    }), _c('span', [_vm._v(_vm._s(_vm.$t(item.name)))])]) : _vm._e(), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "nest-menu",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(child.icon) ? _c('icon-svg', {
        attrs: {
          "icon-class": child.icon
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(child.name)))])], 1)], 1)] : _vm._e()
    })], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2684b5cd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 560
// module chunks = 313